 /* global $:true */

import React, { Component, PropTypes } from 'react';
import _ from 'underscore';
import alertify from 'alertify.js';

import Button from '../elements/Button';
import TextInputGroup from '../elements/TextInputGroup';
import FileInputGroup from '../elements/FileInputGroup';

class RegisterSchoolForm extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            full_name: '',
            title: '',
            logo: '',
            address_1: '',
            address_2: '',
            city: '',
            county: '',
            postcode: '',
            email: '',
            username: '',
            phone_number: '',
            password: '',
            confirmStaffMember: false,
            agreeTerms: false,
            role: 'senior'
        };
    }

    handleSubmit = (e) => {
        e.preventDefault();

        const { full_name, title, address_1, postcode, email, password, confirmStaffMember, agreeTerms } = this.state;

        let error = null;
        if (full_name.length === 0) {
            error = 'Full name is required';
        } else if (title.length === 0) {
            error = 'School name is required';
        } else if (address_1.length === 0) {
            error = 'Address is required';
        } else if (postcode.length === 0) {
            error = 'Postcode is required';
        } else if (email.length === 0) {
            error = 'School email is required';
        } else if (password.length < 6) {
            error = 'Password is required and should be more then 6 characters';
        } else if (!confirmStaffMember) {
            error = 'Please confirm you are school staff member';
        } else if (!agreeTerms) {
            error = 'Please confirm you agree terms';
        }

        if (!_.isNull(error)) {
            alertify.error(error);
        } else {
            this.props.handleSubmit({ data: this.state, type: 'school' });
        }
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit} id="register-school-form">
                <TextInputGroup
                    name="full_name"
                    label="Full name"
                    placeholder="Your full name"
                    value={this.state.full_name}
                    onChange={e => this.setState({ full_name: e.target.value })}
                    toolTip="E.g. John Doe" />
                <TextInputGroup
                    name="title"
                    label="School name"
                    placeholder="The name of your school"
                    value={this.state.title}
                    onChange={e => this.setState({ title: e.target.value })}
                    toolTip="E.g. Dunraven Primary School" />
                <FileInputGroup
                    name="logo"
                    label="School logo"
                    value={this.state.logo}
                    onChange={e => this.setState({ logo: e.target.value })}
                    toolTip="A jpeg or png image of your school logo" />
                <TextInputGroup
                    name="address_1"
                    label="School address"
                    placeholder="First line"
                    value={this.state.address_1}
                    onChange={e => this.setState({ address_1: e.target.value })}
                    toolTip="The address of your school" />
                <TextInputGroup
                    name="address_2"
                    label={null}
                    placeholder="Second line"
                    value={this.state.address_2}
                    onChange={e => this.setState({ address_2: e.target.value })} />
                <TextInputGroup
                    name="city"
                    label={null}
                    placeholder="City"
                    value={this.state.city}
                    onChange={e => this.setState({ city: e.target.value })} />
                <TextInputGroup
                    name="county"
                    label={null}
                    placeholder="County"
                    value={this.state.county}
                    onChange={e => this.setState({ county: e.target.value })} />
                <TextInputGroup
                    name="postcode"
                    label={null}
                    placeholder="Postcode"
                    value={this.state.postcode}
                    onChange={e => this.setState({ postcode: e.target.value })} />
                <TextInputGroup
                    name="email"
                    label="Your school email address"
                    placeholder="Your email address..."
                    value={this.state.email}
                    onChange={e => this.setState({ email: e.target.value, username: e.target.value })}
                    toolTip="Make sure you use your school email address so we can verify you. E.g. jane.smith@schoolname.sch.uk " />
                <TextInputGroup
                    type="number"
                    name="phone_number"
                    label="Phone number (optional)"
                    placeholder="Your phone number"
                    value={this.state.phone_number}
                    onChange={e => this.setState({ phone_number: e.target.value })}
                    toolTip="The best telephone number to reach you on in working hours." />
                <TextInputGroup
                    type="password"
                    name="password"
                    label="Password"
                    value={this.state.password}
                    onChange={e => this.setState({ password: e.target.value })}
                    toolTip="A strong password is at least 7 characters long and contains a number, capital and symbol." />
                <p>
                    <input
                        type="checkbox"
                        value={this.state.confirmStaffMember}
                        onChange={() => this.setState({ confirmStaffMember: !this.state.confirmStaffMember })} />
                    &nbsp;I confirm that I am a staff member&nbsp;
                    <a data-toggle="tooltip" title="If you are not a school then please register for a parent account instead.">
                        <i className="fa fa-info-circle" />
                    </a>
                </p>
                <p>
                    <input
                        type="checkbox"
                        value={this.state.agreeTerms}
                        onChange={() => this.setState({ agreeTerms: !this.state.agreeTerms })} />
                    &nbsp;I agree to the Clever Tykes <a href="http://clevertykes.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer">terms and conditions</a>
                </p>
                <p>
                    <Button>
                        <p>Submit</p>
                    </Button>
                </p>
            </form>
        );
    }
}

RegisterSchoolForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired
};

module.exports = RegisterSchoolForm;



/** WEBPACK FOOTER **
 ** ./src/forms/RegisterSchoolForm.js
 **/